import Select, { components, ValueContainerProps } from 'react-select';
import { RemovedProductsCategory } from '../constant/constant';

const BundleScriptRangeFilters = (props: any) => {
  const ValueContainer = ({ children, ...props }: ValueContainerProps<any>) => {
    let [values, input] = children as any;

    if (Array.isArray(values)) {
      const plural = values.length === 1 ? '' : 's';
      values = `${values.length} item${plural} selected`;
    }

    return (
      <components.ValueContainer {...props}>
        {values}
        {input}
      </components.ValueContainer>
    );
  };

  return (
    <>
      <small className="ml-5">Category</small>
      <Select
        classNames={{
          control: (state) =>
            `${
              state.isFocused
                ? 'border-grey-400 border text-sm'
                : 'border-grey-400 border text-sm'
            } w-60 cursor-pointer ml-2`,
        }}
        value={
          localStorage.getItem('productCategroy')
            ? JSON.parse(localStorage.getItem('productCategroy') as string)
            : props.sortByCategory
        }
        options={props.productCategory
          ?.filter(
            (product: { value: string }) =>
              !RemovedProductsCategory.includes(product.value),
          )
          ?.sort((a: { label: string }, b: { label: any }) =>
            a.label.localeCompare(b.label),
          )}
        onChange={(selected) => {
          props.setSortByCategory([...selected]);
          localStorage.setItem('productCategroy', JSON.stringify(selected));
        }}
        isSearchable
        hideSelectedOptions={false}
        isMulti
        isClearable
        components={{ ValueContainer }}
      />
      <small className="ml-5">Formulation</small>
      <Select
        classNames={{
          control: (state) =>
            `${
              state.isFocused
                ? 'border-grey-400 border text-sm'
                : 'border-grey-400 border text-sm'
            } w-60 cursor-pointer ml-2`,
        }}
        value={
          localStorage.getItem('productFormulation')
            ? JSON.parse(localStorage.getItem('productFormulation') as string)
            : props.sortByFormulation
        }
        options={props.productFormulation?.sort(
          (a: { label: string }, b: { label: string }) =>
            a.label.localeCompare(b.label),
        )}
        onChange={(selected) => {
          props.setSortByFormulation([...selected]);
          localStorage.setItem('productFormulation', JSON.stringify(selected));
        }}
        isSearchable
        hideSelectedOptions={false}
        isMulti
        isClearable
        components={{ ValueContainer }}
      />
    </>
  );
};

export default BundleScriptRangeFilters;
